import type { Catalog } from '@smarton-pbx/shared';

export const people: Catalog = {
  // Words several of these screens use.
  'Actions for {name}': 'Veiksmai: {name}',
  'Edit {name}': 'Redaguoti: {name}',
  'Remove {name}': 'Pašalinti: {name}',
  'Save changes': 'Išsaugoti pakeitimus',
  'All regions': 'Visi regionai',

  // People.
  Disabled: 'Išjungtas',
  Invited: 'Pakviestas',
  'person|Active': 'Aktyvus',
  Away: 'Nėra',
  'Reset the 2-step sign-in for {name}? They set it up again at their next sign-in.':
    'Iš naujo nustatyti dviejų žingsnių prisijungimą? {name} jį vėl nustatys, kai kitą kartą prisijungs.',
  '{name} will set up their authenticator app again at the next sign-in.': '{name} iš naujo nustatys autentifikavimo programėlę, kai kitą kartą prisijungs.',
  'Everyone who can sign in, and their extensions.': 'Visi, kurie gali prisijungti, ir jų vidiniai numeriai.',
  'The people in your region.': 'Jūsų regiono darbuotojai.',
  'Add person': 'Pridėti darbuotoją',
  'Search people': 'Ieškoti darbuotojų',
  '{n} of {total}': '{n} iš {total}',
  'No one matches': 'Nieko nerasta',
  'No people yet': 'Darbuotojų dar nėra',
  'Add the people who make and take calls. Each gets an invite link.': 'Pridėkite darbuotojus, kurie skambina ir atsiliepia. Kiekvienas gaus kvietimo nuorodą.',
  Extension: 'Vidinis numeris',
  Status: 'Būsena',
  'When they can’t answer': 'Kai negali atsiliepti',
  'Password reset link': 'Slaptažodžio atkūrimo nuoroda',
  'Invite link': 'Kvietimo nuoroda',
  'Reset 2-step sign-in': 'Iš naujo nustatyti dviejų žingsnių prisijungimą',
  'Link for {name}': 'Nuoroda: {name}',
  'They get a one-time link to set their password.': 'Darbuotojas gaus vienkartinę nuorodą slaptažodžiui nustatyti.',
  'Add a region first: everyone except admins belongs to one.': 'Pirmiausia pridėkite regioną: visi, išskyrus administratorius, priklauso kuriam nors regionui.',
  'Their internal number': 'Numeris skambučiams tarp kolegų',
  'Mobile number': 'Mobiliojo telefono numeris',
  'Optional. For forwarding unanswered calls': 'Neprivaloma. Neatsilieptiems skambučiams nukreipti',
  'Disabled: can’t sign in or take calls': 'Išjungtas: negali prisijungti ir priimti skambučių',

  // Regions.
  'No notice': 'Be įspėjimo',
  'Reminder to staff': 'Priminimas darbuotojams',
  'Delete the region {name}?': 'Ištrinti regioną „{name}“?',
  'Add region': 'Pridėti regioną',
  'Countries or offices. Each has its own languages, recording notice and allowed destinations.':
    'Šalys arba biurai. Kiekvienas turi savo kalbas, įspėjimą apie įrašymą ir leidžiamas skambučių kryptis.',
  'No regions yet': 'Regionų dar nėra',
  'Add one for each country or office, then add people to it.': 'Pridėkite po regioną kiekvienai šaliai ar biurui, tada priskirkite jam darbuotojus.',
  'Time zone': 'Laiko juosta',
  Languages: 'Kalbos',
  'Recording notice': 'Įspėjimas apie įrašymą',
  'Move its people to another region first': 'Pirmiausia perkelkite jo darbuotojus į kitą regioną',
  Country: 'Šalis',
  'Numbers dialled without a country code are read as this country’s': 'Numeriai be šalies kodo laikomi šios šalies numeriais',
  'For reports and opening hours': 'Ataskaitoms ir darbo laikui',
  'Keep recordings for (days)': 'Saugoti įrašus (dienomis)',
  'Then they’re deleted with their transcripts': 'Po to jie ištrinami kartu su transkripcijomis',
  'Call languages': 'Pokalbių kalbos',
  'The first is the main language; calls are transcribed in these.': 'Pirmoji – pagrindinė kalba; pokalbiai transkribuojami šiomis kalbomis.',
  'Other countries staff may call': 'Kitos šalys, į kurias darbuotojai gali skambinti',
  'Calls within the region’s own country are always allowed. Calls to other countries not listed here are refused.':
    'Skambinti regiono šalies numeriais leidžiama visada. Skambučiai į kitas čia nenurodytas šalis atmetami.',
  'Add a country': 'Pridėti šalį',

  // Audit log: what each entry means.
  'Played a recording': 'Paleido įrašą',
  'Downloaded a recording': 'Atsisiuntė įrašą',
  'Paused recording during a call': 'Pristabdė įrašymą pokalbio metu',
  'Resumed recording during a call': 'Vėl įjungė įrašymą pokalbio metu',
  'Listened to a voicemail': 'Perklausė balso žinutę',
  'Declined a call': 'Atmetė skambutį',
  'Corrected a call’s outcome': 'Pataisė skambučio rezultatą',
  'Corrected a call’s reasons': 'Pataisė skambučio priežastis',
  'Corrected a transcript line': 'Pataisė transkripcijos eilutę',
  'Marked a transcript as checked': 'Pažymėjo transkripciją kaip patikrintą',
  'Transcribed a call again': 'Iš naujo transkribavo skambutį',
  'Deleted old recordings': 'Ištrynė senus įrašus',
  'Added a person': 'Pridėjo darbuotoją',
  'Added a lead': 'Pridėjo potencialų klientą',
  'Deleted a lead': 'Ištrynė potencialų klientą',
  'Exported the pipeline': 'Eksportavo pardavimų eigą',
  'Changed a person': 'Pakeitė darbuotojo duomenis',
  'Made a password link': 'Sukūrė slaptažodžio nuorodą',
  'Reset two-step sign-in': 'Iš naujo nustatė dviejų žingsnių prisijungimą',
  'Set a photo': 'Įkėlė nuotrauką',
  'Downloaded a table as Excel': 'Atsisiuntė lentelę kaip Excel',
  'Table downloads': 'Lentelių atsisiuntimai',
  '{n} rows': { one: '{n} eilutė', few: '{n} eilutės', other: '{n} eilučių' },
  'Last sign-in': 'Paskutinis prisijungimas',
  'Removed a photo': 'Pašalino nuotrauką',
  'Set their password': 'Nustatė savo slaptažodį',
  'Changed their password': 'Pakeitė savo slaptažodį',
  'Turned on two-step sign-in': 'Įjungė dviejų žingsnių prisijungimą',
  'Added a region': 'Pridėjo regioną',
  'Changed a region': 'Pakeitė regioną',
  'Removed a region': 'Pašalino regioną',
  'Added a number': 'Pridėjo numerį',
  'Changed a number': 'Pakeitė numerį',
  'Removed a number': 'Pašalino numerį',
  'Added a carrier': 'Pridėjo ryšio operatorių',
  'Changed a carrier': 'Pakeitė ryšio operatorių',
  'Removed a carrier': 'Pašalino ryšio operatorių',
  'Changed call settings': 'Pakeitė skambučių nustatymus',
  'Changed notification defaults': 'Pakeitė numatytuosius pranešimų nustatymus',
  'Changed transcription settings': 'Pakeitė transkribavimo nustatymus',
  'Changed AI analysis settings': 'Pakeitė DI analizės nustatymus',
  'Changed the recording notice': 'Pakeitė įspėjimą apie įrašymą',
  'Uploaded an announcement': 'Įkėlė įspėjimo įrašą',
  'Removed an announcement': 'Pašalino įspėjimo įrašą',
  'Added a reason category': 'Pridėjo priežasčių kategoriją',
  'Changed a reason category': 'Pakeitė priežasčių kategoriją',
  'Changed branding': 'Pakeitė įmonės išvaizdą',
  'Uploaded a logo or icon': 'Įkėlė logotipą ar piktogramą',
  'Removed a logo or icon': 'Pašalino logotipą ar piktogramą',
  'Created the account': 'Sukūrė įmonės paskyrą',
  'Changed the account': 'Pakeitė įmonės paskyrą',
  'Added an administrator': 'Pridėjo administratorių',
  'Suspended the account': 'Sustabdė įmonės paskyrą',
  'Reactivated the account': 'Vėl aktyvavo įmonės paskyrą',

  // Audit log.
  Everything: 'Viskas',
  Recordings: 'Įrašai',
  'AI review corrections': 'DI vertinimo pataisymai',
  Transcripts: 'Transkripcijos',
  'Automatic deletion': 'Automatinis trynimas',
  Carriers: 'Ryšio operatoriai',
  'Platform staff': 'Platformos darbuotojai',
  'The system': 'Sistema',
  '{name} (platform staff)': '{name} (platformos darbuotojas)',
  'A removed person': 'Pašalintas darbuotojas',
  none: 'nėra',
  '{n} recordings': { one: '{n} įrašas', few: '{n} įrašai', other: '{n} įrašų' },
  '{n} transcripts': { one: '{n} transkripcija', few: '{n} transkripcijos', other: '{n} transkripcijų' },
  '{n} AI reviews': { one: '{n} DI vertinimas', few: '{n} DI vertinimai', other: '{n} DI vertinimų' },
  '{n} voicemails': { one: '{n} balso žinutė', few: '{n} balso žinutės', other: '{n} balso žinučių' },
  'Who played recordings, changed settings or managed people, and what was deleted automatically.':
    'Kas klausė įrašų, keitė nustatymus ar tvarkė darbuotojus ir kas buvo ištrinta automatiškai.',
  'Nothing here yet': 'Čia dar nieko nėra',
  'Entries appear as people use the system.': 'Žurnalo įrašai atsiranda, kai žmonės naudojasi sistema.',
  Who: 'Kas',
  What: 'Veiksmas',
  Details: 'Informacija',
  'the call': 'skambutis',
  'Loading…': 'Įkeliama…',

  // When I can't answer (Your account, and People for admins).
  'When I can’t answer': 'Kai negaliu atsiliepti',
  'When {name} can’t answer': 'Kai {name} negali atsiliepti',
  'Away until {date}': 'Nėra iki {date}',
  'You don’t have a number of your own yet. These settings apply once an admin gives you one on the Numbers page.':
    'Dar neturite savo numerio. Šie nustatymai įsigalios, kai administratorius puslapyje „Numeriai“ jums jį priskirs.',
  '{name} doesn’t have a number of their own yet. These settings apply once an admin gives them one on the Numbers page.':
    '{name} dar neturi savo numerio. Šie nustatymai įsigalios, kai administratorius puslapyje „Numeriai“ priskirs darbuotojui numerį.',
  'They don’t have a number of their own yet. These settings apply once an admin gives them one on the Numbers page.':
    'Darbuotojas dar neturi savo numerio. Šie nustatymai įsigalios, kai administratorius puslapyje „Numeriai“ priskirs darbuotojui numerį.',
  'A call to {numbers} rings your browser and app.': 'Skambutis numeriu {numbers} skamba jūsų naršyklėje ir programėlėje.',
  'A call to {numbers} rings your browser and app (unless you’re on a call).':
    'Skambutis numeriu {numbers} skamba jūsų naršyklėje ir programėlėje (nebent kalbate telefonu).',
  'A call to {numbers} rings their browser and app.': 'Skambutis numeriu {numbers} skamba darbuotojo naršyklėje ir programėlėje.',
  'A call to {numbers} rings their browser and app (unless they’re on a call).':
    'Skambutis numeriu {numbers} skamba darbuotojo naršyklėje ir programėlėje (nebent jis kalba telefonu).',
  'If you don’t answer, it rings your mobile {number}.': 'Jei neatsiliepiate, skamba jūsų mobilusis {number}.',
  'If they don’t answer, it rings their mobile {number}.': 'Jei darbuotojas neatsiliepia, skamba jo mobilusis {number}.',
  'If nobody answers, {colleague}’s browser and app ring; if they don’t answer either, the caller can leave you a message.':
    'Jei niekas neatsiliepia, skamba kolegos naršyklė ir programėlė ({colleague}); jei ir ten neatsiliepiama, skambinantysis gali palikti jums žinutę.',
  'If nobody answers, {colleague}’s browser and app ring; if they don’t answer either, the caller can leave them a message.':
    'Jei niekas neatsiliepia, skamba kolegos naršyklė ir programėlė ({colleague}); jei ir ten neatsiliepiama, skambinantysis gali palikti žinutę darbuotojo balso pašte.',
  'If nobody answers, the call goes to the {queue} queue, and its own settings take it from there.':
    'Jei niekas neatsiliepia, skambutis nukreipiamas į eilę „{queue}“, o toliau jį tvarko eilės nustatymai.',
  'If nobody answers, the caller can leave you a message.': 'Jei niekas neatsiliepia, skambinantysis gali palikti jums žinutę.',
  'If nobody answers, the caller can leave them a message.': 'Jei niekas neatsiliepia, skambinantysis gali palikti žinutę darbuotojo balso pašte.',
  'While you’re away, and while you’re on a call, calls skip you and go straight to the last step.':
    'Kol jūsų nėra ir kol kalbate telefonu, skambučiai jus praleidžia ir iškart pereina į paskutinį žingsnį.',
  'While they’re away, and while they’re on a call, calls skip them and go straight to the last step.':
    'Kol darbuotojo nėra ir kol jis kalba telefonu, skambučiai jį praleidžia ir iškart pereina į paskutinį žingsnį.',
  'While you’re away, calls skip you and go straight to the last step.': 'Kol jūsų nėra, skambučiai jus praleidžia ir iškart pereina į paskutinį žingsnį.',
  'While they’re away, calls skip them and go straight to the last step.': 'Kol darbuotojo nėra, skambučiai jį praleidžia ir iškart pereina į paskutinį žingsnį.',
  'While you’re on a call, calls skip you and go straight to the last step.': 'Kol kalbate telefonu, skambučiai jus praleidžia ir iškart pereina į paskutinį žingsnį.',
  'While they’re on a call, calls skip them and go straight to the last step.':
    'Kol darbuotojas kalba telefonu, skambučiai jį praleidžia ir iškart pereina į paskutinį žingsnį.',
  'If nobody answers': 'Jei niekas neatsiliepia',
  'My voicemail': 'Mano balso paštas',
  'Their voicemail': 'Darbuotojo balso paštas',
  'A colleague': 'Kolega',
  'A queue': 'Eilė',
  Colleague: 'Kolega',
  'Choose…': 'Pasirinkite…',
  'When I’m on a call': 'Kai kalbu telefonu',
  'When they’re on a call': 'Kai kalba telefonu',
  'Ring me anyway': 'Vis tiek skambinti man',
  'Ring them anyway': 'Vis tiek skambinti',
  'Skip me': 'Praleisti mane',
  'Skip them': 'Praleisti',
  Mobile: 'Mobilusis',
  'No mobile number. An admin adds it on the People page.': 'Mobiliojo numerio nėra. Jį prideda administratorius puslapyje „Darbuotojai“.',
  'Rings after your browser and app': 'Skamba po naršyklės ir programėlės',
  'Rings after their browser and app': 'Skamba po naršyklės ir programėlės',
  'Doesn’t ring': 'Neskamba',
  From: 'Nuo',
  'Empty: from now': 'Tuščia – nuo dabar',
  'Last day away': 'Paskutinė diena',
  'While away, your browser, app and mobile don’t ring, your queues skip you, and colleagues calling you hear that you can’t answer. It ends by itself after the last day.':
    'Kol jūsų nėra, jūsų naršyklė, programėlė ir mobilusis neskamba, eilės jus praleidžia, o jums skambinantys kolegos išgirsta, kad negalite atsiliepti. Po paskutinės dienos tai baigiasi savaime.',
  'While away, their browser, app and mobile don’t ring, their queues skip them, and colleagues calling them hear that they can’t answer. It ends by itself after the last day.':
    'Kol darbuotojo nėra, jo naršyklė, programėlė ir mobilusis neskamba, eilės jį praleidžia, o jam skambinantys kolegos išgirsta, kad jis negali atsiliepti. Po paskutinės dienos tai baigiasi savaime.',
  'I’m back': 'Grįžau',
  'They’re back': 'Grįžo',
  'Not away': 'Atšaukti nebuvimą',
  'Saved.': 'Išsaugota.',
  'Voicemail greeting': 'Balso pašto pasisveikinimas',
  'Callers who leave you a message hear your own greeting in their language, e.g. “You’ve reached Jonas from sales. Leave a message after the tone and I’ll call you back.” Without one, they hear the standard greeting.':
    'Skambinantieji, paliekantys jums žinutę, išgirsta jūsų pasisveikinimą savo kalba, pvz., „Skambinate Jonui iš pardavimų skyriaus. Palikite žinutę po signalo ir aš jums perskambinsiu.“ Jei pasisveikinimo nėra, jie išgirsta įprastą.',
  'Callers who leave them a message hear their own greeting in their language, e.g. “You’ve reached Jonas from sales. Leave a message after the tone and I’ll call you back.” Without one, they hear the standard greeting.':
    'Skambinantieji, paliekantys darbuotojui žinutę, išgirsta jo pasisveikinimą savo kalba, pvz., „Skambinate Jonui iš pardavimų skyriaus. Palikite žinutę po signalo ir aš jums perskambinsiu.“ Jei pasisveikinimo nėra, jie išgirsta įprastą.',
  'Use a file under 5 MB.': 'Naudokite mažesnį nei 5 MB failą.',
  '{language} greeting': 'Pasisveikinimas: {language}',
  'Converting…': 'Konvertuojama…',
  'Standard greeting': 'Įprastas pasisveikinimas',
  'Stop · {n} s': 'Sustabdyti · {n} s',
  Record: 'Įrašyti',
  Replace: 'Pakeisti',
  Upload: 'Įkelti',
  'Remove the {language} greeting': 'Pašalinti pasisveikinimą: {language}',

  // A person's photo (their account, People).
  'Add a photo': 'Pridėti nuotrauką',
  'Change photo': 'Keisti nuotrauką',
  'Remove photo': 'Pašalinti nuotrauką',
  'Photos can be up to 15 MB.': 'Nuotrauka gali būti ne didesnė nei 15 MB.',
};
